import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type PasswordSignInUserCountFetchFailedAction = {
	type: 'PASSWORD_SIGN_IN_USER_COUNT_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): PasswordSignInUserCountFetchFailedAction => ({
	type: 'PASSWORD_SIGN_IN_USER_COUNT_FETCH_FAILED',
	payload,
});
